import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import Backdrop from './backDrop';

import './shareModal.css';

const ModalOverlay = React.forwardRef((props, ref ) => {
    const content = (
        <main ref={ref} className={`shareModal ${props.className}`} style={props.style}>
            <h1>Adding Book</h1>
            <div className={`shareModal-container ${props.containerClass}`}>
                <div className={`shareModal-content ${props.contentClass}`}>
                    {props.children}
                </div>
            </div>
        </main>
    );
    return ReactDOM.createPortal(content, document.getElementById('shareModal-hook')) 
});

const ShareModal = (props) => {
    const nodeRef = useRef(null)
    return (
        <React.Fragment>
            {props.show && <Backdrop onClick={props.onCancel}/>}
            <CSSTransition
              in={props.show}
              mountOnEnter
              unmountOnExit
              timeout={2}
              classNames='shareModal'
              nodeRef={nodeRef}>
                <ModalOverlay {...props} ref={nodeRef}/>
            </CSSTransition>
        </React.Fragment>
    )
}

export default ShareModal;